import { Filter, ScheduleState } from './types'

export const state: ScheduleState = {
  filterOpen: false,
  filter: Filter.ALL,
  showRequests: false,
  loadingAllModules: false,
  doctorModules: [],
  pendingConsultations: [],
  loadingPendingConsultations: false,
  scheduledConsultations: [],
  loadingScheduledConsultations: false,
  loadingCancelConsultations: false
}
